export default {
	position: '#',
	username: 'Имя',
	gift: 'Приз',
	score: 'Очки',
};
